<template>
  <div>
    <div class="tab">
      <el-button
        @click="changIsCollapse"
        :style="{ width: !isCollapse ? '201px' : '64px' }"
        >{{ de }}</el-button
      >
      <!-- <el-menu
        @select="select"
        :default-active="tablist[0].children[0].path"
        class="el-menu-vertical-demo"
        background-color="#F0F6F6"
        text-color="#3C3F41"
        active-text-color="#409eff"
      >
        <nav-menu :navMenus="tablist"></nav-menu>
      </el-menu>-->
      <el-menu
        :collapse="isCollapse"
        background-color="#F0F6F6"
        :default-active="defaults"
        text-color="#3C3F41"
        active-text-color="#409eff"
        class="el-menu-vertical-demo"
        @select="select"
      >
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>APP相关</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/appUser">APP用户管理</el-menu-item>
            <el-menu-item v-if="name == 'admin'" index="/appRun"
              >APP应用管理</el-menu-item
            >
            <el-menu-item index="/registerList">用户注册审核管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu v-if="openStat == 1" index="2">
          <template slot="title">
            <i class="el-icon-s-tools"></i>
            <span>统计汇总</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/stateLogin">登录统计</el-menu-item>
            <el-menu-item index="/stateTotal">登录汇总</el-menu-item>
            <!-- <el-menu-item index="/jigouTongji">机构统计</el-menu-item> -->
            <el-menu-item index="/hospitalTotal">医院汇总列表</el-menu-item>
            <el-menu-item index="/hospitalSumMore">医院汇总统计</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3" v-if="grp != 4">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>第三方统计汇总</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/siteState">站点统计</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/user">
          <i class="el-icon-menu"></i>
          <span slot="title">系统用户管理</span>
        </el-menu-item>
        <el-menu-item v-if="name == 'admin'" index="/org">
          <i class="el-icon-document"></i>
          <span slot="title">组织机构</span>
        </el-menu-item>
        <el-submenu index="16">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>AI相关</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/aiUser">AI用户</el-menu-item>
            <el-menu-item v-if="name == 'admin'" index="/aiOrg"
              >AI组织</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>

        <el-menu-item v-if="name == 'admin'" index="/partyLogin">
          <i class="el-icon-document"></i>
          <span slot="title">第三方账号管理</span>
        </el-menu-item>
        <el-menu-item v-if="name == 'admin' || grp == '2'" index="/jigouTongji">
          <i class="el-icon-document"></i>
          <span slot="title">机构统计</span>
        </el-menu-item>

        <el-submenu v-if="openStat == 1" index="4">
          <template slot="title">
            <i class="el-icon-s-tools"></i>
            <span>外文统计汇总</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/foreignStateLogin">登录统计</el-menu-item>
            <el-menu-item index="/foreignStateTotal">登录汇总</el-menu-item>
            <!-- <el-menu-item index="/jigouTongji">机构统计</el-menu-item> -->
            <el-menu-item index="/foreignDate">数据统计</el-menu-item>
            <el-menu-item index="/foreignHospitalSumMore"
              >医院汇总</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
        <!-- <el-menu-item index="4">
        <i class="el-icon-setting"></i>
        <span slot="title">导航四</span>
        </el-menu-item>-->
      </el-menu>
    </div>
  </div>
</template>

<script>
import navMenu from "../components/menuTemplate";
export default {
  components: {
    navMenu,
  },
  created() {
    this.openStat = sessionStorage.getItem("openStat")
      ? sessionStorage.getItem("openStat")
      : 0;
    this.grp = sessionStorage.getItem("grp")
      ? sessionStorage.getItem("grp")
      : 3;
    this.defaults = sessionStorage.getItem("tab");
    this.name = sessionStorage.getItem("admin");
  },
  data() {
    return {
      tablist: [],
      openStat: 0,
      grp: 3,
      defaults: "",
      name: "",
      isCollapse: false,
      de: "收起",
    };
  },
  methods: {
    select(key, path) {
      this.$router.push({ path: key });
      sessionStorage.setItem("tab", key);
      // console.log(key,path);
    },
    changIsCollapse() {
      this.isCollapse = !this.isCollapse;
      this.de = this.isCollapse ? "展开" : "收起";
    },
  },
};
</script>

<style scoped>
/* .tab {
  float: left;
  width: 15rem;
}
.tab::after {
  content: "";
  display: block;
  clear: both;
} */
.tab > ::v-deep button {
  transition: 0.4s;
  border-bottom: none;
  background-color: rgb(240, 246, 246);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  font-weight: bold;
}
</style>